






























































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnFormContent, AcgnFormTitle } from '@/components/';
import { AcgnAppointDetail } from './components/index';
import { namespace } from 'vuex-class';
import { AcgnPop } from '@acgn/herm/src/ui';
import { DatePicker } from 'element-ui';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { Link, Image } from 'element-ui';
import event from '@acgn/herm/src/util/event';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
// import { unitTypes } from '@/constants/type-helper';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const CommGetter = namespace('desk/comm').Getter;
const AuthGetter = namespace('desk/auth').Getter;
import {
  refreshStep
} from '@/api/comic';
@Component({
  components: {
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTable,
    AcgnPop,
    AcgnAppointDetail,
    [Link.name]: Link,
    [DatePicker.name]: DatePicker,
    [Image.name]: Image
  }
})

/**
 * 任务稿件组件
 */
export default class AcgnTaskAuditing extends Vue {
  @Prop() public data: any; // 传入数据
  @Prop() public refresh: any; // 刷新
  @Prop() public refreshApproList: any; // 刷新审批列表
  private chapter: any = ''; // 章节
  private visible: any = false;
  private visibleTime: any = false;
  private visibleReset: any = false;
  private cellNumber: any = 0;
  private endDate: any = '';
  private appoint: any = false;
  private linkId: any = 0;
  // private unitTypes: any = unitTypes;
  private defaultUserImage: string = 'https://activity-resource.oss-cn-hangzhou.aliyuncs.com/h5_activity_product/icon/user_img.jpeg'; // 默认头像
  @TaskGroupAction private editLinkInfo: any; // 获取漫画项目列表
  @TaskGroupAction private resetLink: any;  // 重置环节
  @CommGetter private attributeData: any; // 公共类型
  @AuthGetter private userInfo: any;
  private get unitTypes() {
    return this.attributeData.unit_type;
  }
  private get attachImages() {
    return JSON.parse(this.data.files[0].attach_images);
  }

  private pickerOptions: any = {
    disabledDate(time: any) {
      return time.getTime() + 86400000 <= Date.now(); // 选当前时间之后的时间
    }
  };

  // 编辑件数
  private editCellNumber() {
    this.visible = true;
  }
  private close() {
    this.visible = false;
    this.visibleTime = false;
    this.visibleReset = false;
  }

  private setDateTimeStamp(date: any) {
    return setDateTimeStamp(date, 'YYYY-MM-DD HH:mm:ss');
  }

  // 提交件数
  private async submit() {
    const date = this.setDateTimeStamp(this.data.over_submit_time);
    const params = {
      link_id: this.data.id,
      cell_number: this.cellNumber,
      over_submit_time: getDateTimeStamp(date , 'YYYY-MM-DD HH:mm:ss')
    };
    await this.editLinkInfo(params);
    this.refresh();
    this.$message.success('保存成功');
    this.visible = false;
  }

  // 编辑截止时间
  private editEndTime() {
    this.visibleTime = true;
  }

  // 提交截止时间
  private async submitEndTime() {
    const params = {
      link_id: this.data.id,
      cell_number: this.data.cell_number,
      over_submit_time: getDateTimeStamp(this.endDate , 'YYYY-MM-DD HH:mm:ss')
    };
    await this.editLinkInfo(params);
    this.refresh();
    this.$message.success('保存成功');
    this.visibleTime = false;
  }

  // 重置
  private reset() {
    this.visibleReset = true;
  }

  // 重置确认
  private async submitReset() {
    const params = {
      link_id: this.data.id,
    };
    await this.resetLink(params);
    this.refresh();
    this.$message.success('重置成功');
    this.visibleReset = false;
  }

  // 审批详情
  private getAppro(data: any) {
    this.refreshApproList(data);
  }

  // 上传稿件
  private uploadFile(data: any) {
    event.emit('$uploadFile', data);
  }

  // 指派
  private getAppoint() {
    this.appoint = true;
  }

  // 审批状态样式
  private getStaClass(status: any) {
    switch (status) {
      case 1:
        return 'acgn-succ';
      case 2:
        return 'acgn-ing';
      case 3:
        return 'acgn-refuse';
      case 4:
        return 'acgn-pass';
      case 5:
        return 'acgn-succ';
    }
  }

  // 图片src
  private getImageListStr(item: any) {
    return `${(window as any).configs.imageDomain + item}`;
  }
  // 图片列表
  private getImageList(item: any) {
    return [`${(window as any).configs.imageDomain + item}`];
  }

  // 附件下载地址
  private getFileList(item: any) {
    const str = item.toString();
    if (str.startsWith('http://') || str.startsWith('https://') ) {
      return str.replace('http://', 'https://');
    }
    return `${(window as any).configs.imageDomain + item}`;
    // return item;
  }

  // 逾期 审批
  private get statusOverdue() {
    return this.attributeData.other_type[1][1].name;
  }

  // 逾期 提交
  private get statusSubmit() {
    return this.attributeData.other_type[2][1].name;
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[0];
  }

  // 审批状态名称
  private getStaName(status: any) {
    return this.statusName[status - 1].name;
  }
  // 任务组-重置环节
  private refreshStepHanddle(files: any) {
    refreshStep({
      id: files.instances_id
    }).then((res) => {
      const { status, data } = res;
      if (status === 0 && data) {
        this.refresh();
      }
    });
  }
}
